import React, { useState } from 'react';
import Select from 'react-select';
import AIGradingPanel from './AIGradingPanel';
import useFetchData from '../hooks/useFetchData';

export default function SponsoredCohortAssignmentRawData() {
  const [cohortId, setCohortId] = useState('');
  const [cohortCourseId, setCohortCourseId] = useState('');
  const [cohortModules, setCohortModules] = useState([]);
  const [courseId, setCourseId] = useState('');
  const [moduleId, setModuleId] = useState('');
  const [weekId, setWeekId] = useState('');
  const [assignmentId, setAssignmentId] = useState('');
  const [assignmentTitle, setAssignmentTitle] = useState('');

  const { data: cohortData } = useFetchData(
    ['cohorts'],
    '/cohorts',
    {},
    "Couldn't get cohorts. Please try again!",
    true
  );

  const cohortOptions = cohortData
    ? cohortData?.data?.cohorts?.map((cohort) => ({
        value: cohort.id,
        label: `${cohort.name} (${cohort.no_of_students || 0} Students)`,
        enrolled_course: cohort?.course_id ? cohort.course_id : null,
        enrolled_modules: cohort?.modules ? cohort?.modules : [],
      }))
    : [];

  // get courses

  const { data: courses } = useFetchData(
    ['courses', cohortCourseId],
    '/courses',
    { params: { courses_ids: JSON.stringify([cohortCourseId]) } },
    "Couldn't fetch courses. Please try again!",
    !!cohortId
  );

  const courseOptions = courses
    ? courses?.data?.courses?.map((course) => ({
        value: course.id,
        label: course.courseName,
      }))
    : [];

  // get modules
  const { data: courseModules } = useFetchData(
    ['course-modules', courseId],
    `/course-modules`,
    {
      params: { courseId },
    },
    "Couldn't fetch modules. Please try again!",
    courseId
  );

  const moduleOptions = courseModules
    ? courseModules?.data?.course_modules
        .filter((courseModule) => cohortModules.includes(courseModule.id))
        .map((courseModule) => ({
          value: courseModule.id,
          label: courseModule.moduleName,
        }))
    : [];

  // get module weeks
  const { data: moduleWeeks } = useFetchData(
    ['module-weeks', moduleId],
    `/module-weeks`,
    {
      params: { moduleId },
    },
    "Couldn't fetch weeks. Please try again!",
    moduleId
  );

  const weekOptions = moduleWeeks
    ? moduleWeeks?.data?.weeks?.map((week) => ({
        value: week.id,
        label: week.weekName,
      }))
    : [];

  // get week Assignments
  const { data: weekAssignmentData } = useFetchData(
    ['week-assignments', weekId],
    `/assignments/week/${weekId}`,
    {},
    "Couldn't fetch weeks. Please try again!",
    !!weekId
  );

  const weeklyAssignmentOptions = weekAssignmentData
    ? weekAssignmentData?.data?.assignments?.map((assignment) => ({
        value: assignment.id,
        label: assignment.title,
      }))
    : [];
  const assignment = weekAssignmentData?.data?.assignments?.find(
    (ass) => ass.id === assignmentId
  );
  return (
    <>
      <div className="bg-white rounded-xl border border-gray-200 shadow-sm px-5 py-4">
        <p className="text-xs text-gray-500 leading-relaxed">
          <span className="block text-sm font-semibold text-gray-900 mb-1">
            Cohort Weekly Assignment Raw Data
          </span>
          <span className="block">
            Retrieve comprehensive raw data related to student submissions for a
            specific cohort and assignment. This feature allows you to access
            in-depth details for each student, including their individual
            profiles, submission timestamps.
          </span>
        </p>
      </div>
      <div className="mt-4 grid grid-cols-4 gap-3 bg-white rounded-xl border border-gray-200 shadow-sm p-4">
        <Select
          //   {...field}
          isClearable
          placeholder="Select Cohort"
          className="react-dropdown"
          classNamePrefix="dropdown"
          options={cohortOptions}
          onChange={(event) => {
            setCohortCourseId(event?.enrolled_course);
            setCohortModules(event?.enrolled_modules);
            setCohortId(event?.value || null);
          }}
        />
        <Select
          //   {...field}
          isClearable
          placeholder="Select Course"
          className="react-dropdown"
          classNamePrefix="dropdown"
          options={courseOptions}
          onChange={(event) => {
            setCourseId(event?.value || null);
          }}
        />
        <Select
          //   {...field}
          isClearable
          placeholder="Select Module"
          className="react-dropdown"
          classNamePrefix="dropdown"
          options={moduleOptions}
          onChange={(event) => {
            setModuleId(event?.value || null);
          }}
        />
        <Select
          //   {...field}
          isClearable
          placeholder="Select Week"
          className="react-dropdown"
          classNamePrefix="dropdown"
          options={weekOptions}
          onChange={(event) => {
            setWeekId(event?.value || null);
          }}
        />
        <Select
          //   {...field}
          isClearable
          placeholder="Select Assignment"
          className="react-dropdown"
          classNamePrefix="dropdown"
          options={weeklyAssignmentOptions}
          onChange={(event) => {
            setAssignmentId(event?.value || null);
            setAssignmentTitle(event?.label || null);
          }}
        />
      </div>
      {assignmentId && (
        <AIGradingPanel
          assignmentId={assignmentId}
          assignmentTitle={assignmentTitle}
          grader={assignment?.grader}
        />
      )}
    </>
  );
}
